/* ============================================================================
   ATHLO+ — Social layer (member interest + "who's in")
   ----------------------------------------------------------------------------
   A basic, backend-agnostic community system: members tap "I'm in" on an
   event / club / session, and others can see who's interested + view a light
   profile. NO chat (that lives on Telegram).

   Needs a shared backend (localStorage can't show OTHER members). Set the
   endpoint + mode on <body> from Theme settings → Community:
     data-social-endpoint="<url>"   data-social-mode="appsscript" | "rest"
   - appsscript : GET via JSONP (Apps Script can't send CORS headers), POST
                  fire-and-forget no-cors, then re-read. Great for launch /
                  validation (hundreds–low thousands of members).
     Deploy: helper script hub-social-appsscript.gs (repo root).
   - rest       : normal fetch GET/POST + CORS (Supabase / serverless). Scales
                  to 30k+ members. Deploy: hub-social-supabase.sql + a function.

   INERT until an endpoint is set — renders nothing, no network calls.

   Endpoint contract (both backends implement the same shape):
     GET  ?item=<id>            -> { item, count, members:[{id,name,avatar,archetype}] }
     GET  ?member=<id>          -> { id, name, avatar, archetype, interests:[{item,label}] }
     POST {action:'interest'|'uninterest', item, label, member_id, name, avatar, archetype}
                                -> { ok:true, count }
   Auto-mounts on any element with [data-social-item] (+ optional data-social-label).
   ========================================================================== */
(function () {
  'use strict';
  var B = document.body || document.documentElement;
  var EP = (B.getAttribute('data-social-endpoint') || '').trim();
  var MODE = (B.getAttribute('data-social-mode') || 'appsscript').trim();
  function enabled() { return !!EP; }

  function me() {
    if (!window.HubMember || !window.HubMember.is()) return null;
    var p = {}; try { p = JSON.parse(localStorage.getItem('hub:profile') || '{}') || {}; } catch (e) {}
    var arch = ''; try { var a = JSON.parse(localStorage.getItem('hub:archetype') || 'null'); if (a && a.title) arch = a.title; } catch (e) {}
    // Hub Level, for the chip beside this member in the "who's in" list (see paint()).
    // evaluate(cb, pOverride) takes the CALLBACK FIRST. This read `var s = evaluate(get())`,
    // which was wrong twice over: it put the profile where the callback goes, so cb(state)
    // threw "cb is not a function" — and it threw ASYNCHRONOUSLY, inside jget()'s promise
    // chain, so it surfaced as an unhandled rejection far past this try/catch. It also read
    // a return value evaluate() has never had (state arrives by callback). So `level` was
    // always '' and the chip has never rendered for anyone.
    // Passing pOverride takes evaluate()'s `if (pOverride)` branch, which calls back INLINE —
    // which is what me() needs, being synchronous and called on every refresh and every write.
    // The trade is in that branch: it cannot count joins or referrals (both need a backend
    // round-trip), so this level counts the on-device badges only and can read a tier low for
    // a very active member. Counting them here would mean making me() async.
    var lvl = '';
    try {
      var HP = window.HubProfile;
      if (HP && HP.evaluate) HP.evaluate(function (s) { if (s && s.level) lvl = s.level; }, HP.get());
    } catch (e) {}
    return { id: window.HubMember.id || '', name: p.name || window.HubMember.name || 'Athlete', avatar: p.avatar || '🏃', archetype: arch, level: lvl };
  }

  function jsonp(url) {
    return new Promise(function (res, rej) {
      var cb = 'hubcb_' + Math.random().toString(36).slice(2);
      var s = document.createElement('script');
      function cleanup() { try { delete window[cb]; } catch (e) { window[cb] = undefined; } if (s.parentNode) s.parentNode.removeChild(s); }
      window[cb] = function (d) { res(d); cleanup(); };
      s.onerror = function () { cleanup(); rej(new Error('jsonp')); };
      s.src = url + (url.indexOf('?') < 0 ? '?' : '&') + 'callback=' + cb;
      document.head.appendChild(s);
      setTimeout(function () { if (window[cb]) { cleanup(); rej(new Error('timeout')); } }, 8000);
    });
  }
  function getInterested(item) {
    if (!enabled()) return Promise.resolve(null);
    var u = EP + (EP.indexOf('?') < 0 ? '?' : '&') + 'item=' + encodeURIComponent(item);
    if (MODE === 'rest') return fetch(u).then(function (r) { return r.json(); }).catch(function () { return null; });
    return jsonp(u).catch(function () { return null; });
  }
  function postInterest(item, label, on) {
    if (!enabled()) return Promise.resolve(null);
    var m = me(); if (!m) return Promise.resolve(null);
    // 2026-08-29: ask HubSession before the attribute. Until `locker_token_in_dom` was switched off
    // the attribute always held a permanent token, so reading it directly was safe; now it is empty
    // until hub-session.js mints a short-lived one and writes it back, and a direct read races that
    // round trip. Same bug family as the 2026-08-28 Strava connect outage.
    var tok = '';
    try {
      var s = window.HubSession;
      tok = ((s && typeof s.token === 'function' && s.token()) ||
             (document.body.getAttribute('data-locker-token') || '')).trim();
    } catch (e) {}
    // An interest write with no credential is refused by the backend and looks, to the member, like
    // it worked — the chip toggles and nothing is saved. Refuse it here instead, where it can be seen.
    if (!tok) {
      try { console.error('[hub-social] no locker token — interest not sent.'); } catch (e) {}
      return Promise.resolve(null);
    }
    var payload = { action: on ? 'interest' : 'uninterest', item: item, label: label || '', member_id: m.id, name: m.name, avatar: m.avatar, archetype: m.archetype, token: tok };
    if (MODE === 'rest') return fetch(EP, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }).then(function (r) { return r.json().catch(function () { return null; }); }).catch(function () { return null; });
    return fetch(EP, { method: 'POST', mode: 'no-cors', body: new URLSearchParams(payload) }).then(function () { return { ok: true }; }).catch(function () { return null; });
  }
  function track(name, detail) { if (typeof window.gtag === 'function') window.gtag('event', name, detail || {}); if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, detail || {})); }

  function mount(host, item, label) {
    if (!enabled() || !host || host.__social) return; host.__social = 1;
    var wrap = document.createElement('div'); wrap.className = 'hub-social';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'hub-social__btn';
    var who = document.createElement('div'); who.className = 'hub-social__who';
    wrap.appendChild(btn); wrap.appendChild(who); host.appendChild(wrap);
    var state = { count: 0, members: [], mine: false };
    function paint() {
      btn.innerHTML = '<span aria-hidden="true">✦</span> ' + (state.mine ? 'You’re in' : 'I’m in') + (state.count ? ' · ' + state.count : '');
      btn.classList.toggle('is-on', state.mine);
      who.textContent = '';
      state.members.slice(0, 24).forEach(function (mm) {
        // each member links to their public profile so others can view them
        var c = document.createElement(mm.id ? 'a' : 'span'); c.className = 'hub-social__chip';
        if (mm.id) { c.href = (window.HubProfile && window.HubProfile.profileUrl) ? window.HubProfile.profileUrl(mm.id) : ('/pages/athlete?id=' + encodeURIComponent(mm.id)); }
        c.textContent = (mm.avatar || '🏃') + ' ' + (mm.name || 'Athlete') + (mm.archetype ? ' · ' + mm.archetype : '');
        if (mm.level) { var l = document.createElement('span'); l.className = 'hub-social__level'; l.textContent = mm.level; c.appendChild(l); }
        who.appendChild(c);
      });
    }
    function refresh() {
      getInterested(item).then(function (d) {
        if (!d) return;
        state.members = d.members || []; state.count = d.count || state.members.length;
        var m = me(); state.mine = !!(m && state.members.some(function (x) { return x.id === m.id; }));
        paint();
      });
    }
    btn.addEventListener('click', function () {
      if (!window.HubMember || !window.HubMember.is()) { if (window.HubMember) window.HubMember.openJoin('interest'); return; }
      state.mine = !state.mine; state.count = Math.max(0, state.count + (state.mine ? 1 : -1)); paint();
      track('community_interest', { item: item, on: state.mine });
      var goingIn = state.mine;
      postInterest(item, label, goingIn).then(function (d) {
        // XP: event RSVP. Only on opt-IN of an event:* item, only if the write stuck;
        // ref = item id so the server awards each event at most once (un/re-RSVP safe).
        if (goingIn && d && d.ok !== false && item.indexOf('event:') === 0) {
          try { if (window.HubXP && window.HubXP.award) window.HubXP.award('event_rsvp', item); } catch (e) {}
        }
        setTimeout(refresh, 900);
      });
    });
    paint(); refresh();
  }

  if (enabled() && !document.getElementById('hub-social-css')) {
    var st = document.createElement('style'); st.id = 'hub-social-css';
    st.textContent = '.hub-social{margin-top:.9rem}.hub-social__btn{display:inline-flex;align-items:center;gap:.4em;font:600 .72rem/1 var(--font-mono,monospace);letter-spacing:.05em;text-transform:uppercase;color:var(--muted,#9aa);background:transparent;border:1px solid var(--line,rgba(255,255,255,.16));border-radius:999px;padding:.5em .85em;cursor:pointer;transition:.18s}.hub-social__btn:hover{color:var(--fg,#fff);border-color:var(--fg,#fff)}.hub-social__btn.is-on{color:var(--lime,#B7FF00);border-color:var(--lime,#B7FF00);background:color-mix(in srgb,var(--lime,#B7FF00) 12%,transparent)}.hub-social__who{display:flex;flex-wrap:wrap;gap:.4rem;margin-top:.7rem}.hub-social__chip{font:500 .72rem/1.3 var(--font-mono,monospace);color:var(--muted,#9aa);background:var(--ink-800,#11151B);border:1px solid var(--line,rgba(255,255,255,.12));border-radius:999px;padding:.35em .7em;display:inline-flex;align-items:center;gap:.35em}a.hub-social__chip{cursor:pointer;text-decoration:none;transition:.15s}a.hub-social__chip:hover{color:var(--lime,#B7FF00);border-color:var(--lime,#B7FF00)}.hub-social__level{font-size:.5rem;letter-spacing:.06em;text-transform:uppercase;color:var(--carbon,#0b0e12);background:var(--lime,#B7FF00);border-radius:999px;padding:.2em .45em;line-height:1}';
    (document.head || document.documentElement).appendChild(st);
  }

  function auto() { if (!enabled()) return; document.querySelectorAll('[data-social-item]').forEach(function (h) { mount(h, h.getAttribute('data-social-item'), h.getAttribute('data-social-label') || ''); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto); else auto();
  document.addEventListener('shopify:section:load', auto);

  window.HubSocial = { enabled: enabled, mount: mount, getInterested: getInterested };
})();
